<template>
  <div class="interview-view">
    <h2 v-if="!hideFormName" class="text-primary" style="text-align: center" />
    <div class="interview-view__share">
      <my-tooltip tooltip="Print Evaluation">
        <b-button
          variant="secondary"
          :disabled="!interviewResultData.id"
          class="btn-icon mr-1"
          @click="handlePrint"
        >
          <feather-icon icon="PrinterIcon" />
        </b-button>
      </my-tooltip>
      <my-tooltip tooltip="Share with other staff">
        <b-button variant="success" class="btn-icon" @click="handleShare">
          <feather-icon icon="Share2Icon" />
        </b-button>
      </my-tooltip>
    </div>

    <a-steps
      :current="currentStep"
      type="navigation"
      size="small"
      class="steps"
    >
      <!-- ${formatData.name}  -->
      <a-step
        :title="i18n('labelInterview.information')"
        :status="currentStep == 0 ? 'process' : 'finish'"
        :description="`${dateFormat(formatData.createTime)}`"
        @click="changeStep(true, 0)"
      />
      <!-- ${interviewResultData.createUser ? interviewResultData.createUser.enName : ''}  -->
      <a-step
        :title="i18n('labelInterview.evaluation')"
        :status="
          currentStep == 1
            ? 'process'
            : interviewResultData.id
            ? 'finish'
            : 'wait'
        "
        :description="`${dateFormat(formatData.interviewDate)}`"
        @click="changeStep(interviewResultData.id, 1)"
      />
      <!-- ${leaderProcessApprovers.length>0 ? leaderProcessApprovers[0].enName: ''}  -->
      <a-step
        :title="i18n('labelInterview.benefits')"
        :status="
          currentStep == 2 ? 'process' : processInstanceId2 ? 'finish' : 'wait'
        "
        :description="`${dateFormat(leaderProcessCreateTime)}`"
        @click="changeStep(processInstanceId2, 2)"
      />
      <a-step
        :title="i18n('labelInterview.title6')"
        :status="
          currentStep == 3 ? 'process' : processInstanceId2 ? 'finish' : 'wait'
        "
        :description="`${dateFormat(leaderApprovalTime)}`"
        @click="changeStep(processInstanceId2, 3)"
      />
      <a-step
        :title="i18n('labelInterview.title8')"
        :status="
          currentStep == 4 ? 'process' : data.status >= 25 ? 'finish' : 'wait'
        "
        :description="`${dateFormat(data.confirmOfferTime)}`"
        @click="changeStep(data.status >= 25, 4)"
      />
      <a-step
        :title="i18n('labelInterview.title9')"
        :status="
          currentStep == 5 ? 'process' : data.status >= 27 ? 'finish' : 'wait'
        "
        :description="`${dateFormat(data.contractCreateTime)}`"
        @click="changeStep(data.status >= 27, 5)"
      />
      <a-step
        :title="i18n('labelInterview.title11')"
        :status="
          currentStep == 6 ? 'process' : data.status >= 28 ? 'finish' : 'wait'
        "
        :description="`${dateFormat(data.contractCreateTime)}`"
        @click="changeStep(data.status >= 28, 6)"
      />
      <a-step
        :title="i18n('labelInterview.title10')"
        :status="
          currentStep == 7 ? 'process' : data.entryProcessId ? 'finish' : 'wait'
        "
        :description="`${dateFormat(OnboardingProcessCreateTime)}`"
        @click="changeStep(data.entryProcessId, 7)"
      />
    </a-steps>

    <div class="interview-view-content">
      <template v-if="currentStep == 0">
        <h3 class="text-primary pl-2" style="transform: translateY(12px);">
          {{ i18n('labelInterview.title1') }}

          <my-tooltip :tooltip="confirmInterviewUrl">
            <a :href="confirmInterviewUrl" target="_blank">
              <feather-icon icon="LinkIcon" size="18" />
            </a>
          </my-tooltip>
        </h3>

        <my-form
          style="height: auto;"
          :data="formatData"
          :loading="loading"
          :option="option"
          page-key="view"
          :footer-visible="false"
          width="auto"
        />
        <div class="feedback-box">
          <a-collapse expand-icon-position="right">
            <a-collapse-panel
              key="clarification"
              header="Clarification"
            >
              <b-form-group
                v-for="question in clarificationQuestions"
                :key="question.field"
                :label="question.label"
              >
                <b-form-radio-group
                  :id="`clarification-${question.field}`"
                  :checked="clarificationValue(question.field)"
                  disabled
                  :name="`clarification-${question.field}`"
                  :options="clarificationOptions"
                />
              </b-form-group>
            </a-collapse-panel>
          </a-collapse>
        </div>
        <template v-if="resumeData.id">
          <div
            style="display: flex;justify-content: space-between;align-items: center;padding-right: 16px;padding-bottom: 5px;border-bottom: 1px solid #D9D9D9;"
          >
            <h3
              class="text-primary pl-2"
              style="transform: translateY(12px);display: inline-block;"
            >
              {{ i18n('labelInterview.title2') }}
            </h3>

            <b-button
              variant="primary"
              class="btn p-1 ml-2 mt-1"
              size="sm"
              @click="dowloadResume"
            >
              {{ i18n('labelResume.dowload') }}
            </b-button>
          </div>
        </template>
        <!-- 面试反馈 -->
        <div class="feedback-box">
          <a-collapse expand-icon-position="right">
            <a-collapse-panel key="1" header="Candidate Interview Feedbacks">
              <b-form-group
                label="1. How would you rate the comprehensibility and adequacy of the interview process details and instructions provided to you before the interview?"
              >
                <b-form-radio-group
                  id="skin-radio-group-one"
                  v-model="formatData.feedbackScore.split(',')[0]"
                  disabled
                  name="quesOne"
                  :options="skinOptions"
                />
              </b-form-group>
              <b-form-group
                label="2. How would you evaluate the level of comfort you experienced during the interview process?"
              >
                <b-form-radio-group
                  id="skin-radio-group-two"
                  v-model="formatData.feedbackScore.split(',')[1]"
                  disabled
                  name="quesTwo"
                  :options="skinOptions"
                />
              </b-form-group>
              <b-form-group
                label="3. How relevant were the questions asked during the interview align to the position you applied for?"
              >
                <b-form-radio-group
                  id="skin-radio-group-three"
                  v-model="formatData.feedbackScore.split(',')[2]"
                  disabled
                  name="quesThree"
                  :options="skinOptions"
                />
              </b-form-group>
              <b-form-group
                label="4. How would you assess the interviewer's proficiency in delivering a clear explanation of the company culture, job role, and expectations?"
              >
                <b-form-radio-group
                  id="skin-radio-group-four"
                  v-model="formatData.feedbackScore.split(',')[3]"
                  disabled
                  name="quesFour"
                  :options="skinOptions"
                />
              </b-form-group>
              <b-form-group
                label="5. How satisfied are you with the responses you received when you had the chance to ask questions and seek clarification about the company or the position?"
              >
                <b-form-radio-group
                  id="skin-radio-group-five"
                  v-model="formatData.feedbackScore.split(',')[4]"
                  disabled
                  name="quesFive"
                  :options="skinOptions"
                />
              </b-form-group>
              <b-form-group
                label="6. Please provide any additional comments or suggestions about your interview experience, the interviewers, or the process in general:   "
              >
                <p class="feedback-content">
                  {{ formatData.feedbackContent }}
                </p>
              </b-form-group>
            </a-collapse-panel>
          </a-collapse>
          <!-- <p>Interview Feedbacks</p>
          <p class="feedback-content">
            {{ formatData.feedbackContent }}
          </p> -->
        </div>

        <template v-if="confirmInfoData.id">
          <div>
            <div class="interview-form-line" />
            <h3 class="text-primary pl-2" style="transform: translateY(12px);">
              {{ i18n('labelInterview.title3') }}
            </h3>
            <my-form
              :data="confirmInfoData"
              :option="resumeOption"
              page-key="view"
              :footer-visible="false"
              width="auto"
            >
              <template slot="dowloadForm">
                <b-button
                  variant="primary"
                  class="btn p-1 ml-0-5"
                  size="sm"
                  @click="dowloadConfirmFile"
                >
                  {{ $t('_components.btns.download')
                  }}{{ i18n('labelResume.confirmFile') }}
                </b-button>
              </template>
            </my-form>
          </div>
        </template>
      </template>

      <template v-if="currentStep == 1 && interviewResultData.id">
        <div class="mb-1">
          <h3
            class="text-primary pl-2"
            style="transform: translateY(12px);display: inline-block;"
          >
            {{ i18n('labelInterview.title5') }}
            <my-tooltip v-if="data.status >= 8" :tooltip="confirmPassUrl">
              <a :href="confirmPassUrl" target="_blank">
                <feather-icon icon="LinkIcon" size="18" />
              </a>
            </my-tooltip>
            <p class="text-secondary" style="font-size: 16px">
              {{ i18n('labelInterview.evaluationBy') }}:&nbsp;
              <span class="text-success">{{
                interviewResultData.createUser
                  ? interviewResultData.createUser.enName
                  : ''
              }}</span>
            </p>
          </h3>
          <my-form
            :data="interviewResultData"
            :option="interviewResultOption"
            page-key="view"
            :footer-visible="false"
            width="auto"
          />
        </div>
      </template>

      <template v-if="currentStep == 2 && processInstanceId2">
        <b-overlay
          :show="processLoading2"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <h3 class="text-primary pl-2" style="transform: translateY(12px);">
            {{ i18n('labelInterview.title7') }}
            <my-tooltip v-if="data.status >= 24" :tooltip="confirmOfferUrl">
              <a :href="confirmOfferUrl" target="_blank">
                <feather-icon icon="LinkIcon" size="18" />
              </a>
            </my-tooltip>
          </h3>
          <my-form
            :data="leaderProcessData"
            :option="leaderProcessOption"
            page-key="view"
            :footer-visible="false"
            width="auto"
          />
        </b-overlay>
      </template>

      <template v-if="currentStep == 3 && processInstanceId2">
        <b-overlay
          :show="processLoading2"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <time-line :data="formatHistoryData2" title-hide />
          <b-img
            v-if="processInstanceId2"
            :src="
              `/api/blade-flow/process/diagram-view?processInstanceId=${processInstanceId2}&time=${new Date().getTime()}&processDefinitionId=`
            "
          />
        </b-overlay>
      </template>

      <template v-if="currentStep == 4 && data.status >= 25">
        <iframe :src="`${webUrl}/offerPass?id=${data.id}`" />
      </template>

      <template v-if="currentStep == 5 && data.status >= 27">
        <h3
          class="text-primary pl-2"
          style="transform: translateY(12px);display: inline-block;"
        >
          {{ i18n('labelInterview.title9') }}
          <my-tooltip :tooltip="`${webUrl}/contractPass?id=${data.id}`">
            <a :href="`${webUrl}/contractPass?id=${data.id}`" target="_blank">
              <feather-icon icon="LinkIcon" size="18" />
            </a>
          </my-tooltip>
          <!-- <my-tooltip :tooltip="`http://192.168.102.218:2889/contractPass?id=${data.id}`">
            <a :href="`http://192.168.102.218:2889/contractPass?id=${data.id}`" target="_blank">
              <feather-icon icon="LinkIcon" size="18" />
            </a>
          </my-tooltip> -->
        </h3>
        <edit-contract :id="data.id" page-key="view" />
      </template>

      <template v-if="currentStep == 6 && data.status >= 28">
        <iframe :src="`${webUrl}/contractPass?id=${data.id}`" />
        <!-- <iframe :src="`http://192.168.102.218:2889/contractPass?id=${data.id}`" /> -->
      </template>

      <template v-if="currentStep == 7 && data.entryProcessId">
        <view-page
          :process-id="data.entryProcessId"
          :hide-form-name="true"
          @onLoaded="viewPageOnLoaded"
        />
      </template>
    </div>

    <slot name="audit" />
    <process-share :visible.sync="shareModalShow" :process-id="id" />
  </div>
</template>

<script>
import interviewAPI from '@/api/staff/interview/index'
import resumeAPI from '@/api/staff/resume/index'
// import MyForm from '@/components/myForm/index.vue'
import applyAPI from '@/api/apply/index'
import TimeLine from '@/components/timeLine.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BImg,
  BOverlay,
  BButton,
  BFormGroup,
  BFormRadioGroup,
} from 'bootstrap-vue'
import templateFormAPI from '@/api/templateForm/index'
import { templateFormat } from '@/util/func'
import ProcessShare from '@/components/processShare.vue'
import { getList as getParamList } from '@/api/system/param'
import MyTooltip from '@/components/myTooltip.vue'
import { getStore, setStore } from '@/util/store'
import ViewPage from '@/views/apply/components/viewPage.vue'
import EditContract from './editContract.vue'
import { formatPhoneNumber } from '@/util/util'
export default {
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    TimeLine,
    BImg,
    BOverlay,
    BButton,
    BFormGroup,
    BFormRadioGroup,
    ProcessShare,
    MyTooltip,
    EditContract,
    ViewPage,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    audit: {
      type: Boolean,
      default: false,
    },
    hideFormName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {},
      loading: false,
      hasToStringTypes: ['select'],
      // processInstanceId: '',
      processInstanceId2: '',
      historyData: [],
      clarificationOptions: [
        { text: 'Yes', value: '1' },
        { text: 'No', value: '2' },
      ],
      clarificationQuestions: [
        {
          field: 'disease',
          label:
            'Have you been or are you suffering from any physical impairment, major medical condition, mental illness, or disease?',
        },
        {
          field: 'terminatedEmployment',
          label:
            'Have you ever been terminated or dismissed for the services of your previous employment?',
        },
        {
          field: 'convicted',
          label:
            'Have you been convicted in a Court of law in any country or any ongoing legal proceedings?',
        },
        {
          field: 'bankrupt',
          label: 'Have you ever been declared a bankrupt?',
        },
        {
          field: 'relativesInMcc',
          label:
            'Do you have family members, relatives or friends working in MCC Group?',
        },
      ],
      skinOptions: [
        { text: 'N.A', value: '0' },
        { text: 'Poor', value: '1' },
        { text: 'Neutral', value: '2' },
        { text: 'Good', value: '3' },
        { text: 'Excellent', value: '4' },
      ],
      historyData2: [],
      processLoading: false,
      processLoading2: false,
      confirmInfoData: {},
      resumeData: {},
      interviewResultData: {},
      interviewPassFormId: 16,
      interviewLeaderFormId: 32,
      interviewResultColumns: [],
      leaderProcessColumns: [],
      leaderProcessData: {},
      leaderProcessApprovers: [],
      leaderProcessCreateTime: '',
      shareModalShow: false,
      // 邮件URL
      confirmInterviewUrl: '',
      confirmPassUrl: '',
      confirmOfferUrl: '',
      formName: '',
      // steps
      currentStep: 0,

      OnboardingProcessCreateTime: '',
      webUrl: '',
    }
  },
  computed: {
    option() {
      const columns = [
        // 列的其他配置可参考vue-good-table
        {
          label: this.i18n('labelInterview.name'),
          field: 'name',
          formOption: {
            // 表单配置
            span: 4,
            rules: 'required', // 规则参考vee-validate文档
          },
        },
        {
          label: this.i18n('labelInterview.jobId'),
          field: 'jobName',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelInterview.sex'),
          field: 'sex',
          dictField: 'sexName',
          formOption: {
            span: 4,
            type: 'select',
            dictBizCode: 'gender',
          },
        },
        {
          label: this.i18n('labelInterview.mobile'),
          field: 'mobile',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelInterview.email'),
          field: 'email',
          formOption: {
            span: 4,
            rules: 'email',
          },
        },
        {
          label: this.i18n('labelInterview.interviewDate'),
          field: 'interviewDate',
          formOption: {
            span: 4,
            type: 'dateTime',
          },
        },
        {
          label: this.i18n('labelJob.companyId'),
          field: 'companyId',
          formOption: {
            span: 4,
            type: 'select',
            dictCode: 'company',
          },
        },
        {
          label: this.i18n('labelInterview.projectId'),
          field: 'projectId',
          formOption: {
            span: 4,
            type: 'select',
            dictCode: 'project',
            customPannel: true,
          },
        },
        {
          label: this.i18n('labelJob.deptId'),
          field: 'deptId',
          formOption: {
            span: 4,
            type: 'select',
            dictCode: 'dept',
            customPannel: true,
          },
        },
        {
          label: this.i18n('labelInterview.status'),
          field: 'status',
          formOption: {
            span: 4,
            type: 'select',
            dictBizCode: 'interview_ process_status',
          },
        },
      ]
      const option = {
        columns,
      }
      return option
    },
    resumeOption() {
      const columns = [
        {
          label: this.i18n('labelResume.photo'),
          field: 'photoFiles',
          formOption: {
            type: 'upload',
            span: 4,
          },
        },
        // 列的其他配置可参考vue-good-table

        {
          label: this.i18n('labelResume.name'),
          field: 'enName',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.sex'),
          field: 'sex',
          formOption: {
            type: 'select',
            dictBizCode: 'gender',
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.nric'),
          field: 'nric',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.mobile'),
          field: 'mobile',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.email'),
          field: 'email',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.nationality'),
          field: 'nationality',
          formOption: {
            type: 'select',
            dictBizCode: 'nationality',
            span: 4,
          },
        },

        {
          label: this.i18n('labelResume.highestEducation'),
          field: 'highestEducation',
          formOption: {
            type: 'select',
            dictBizCode: 'qualification',
            span: 4,
          },
        },

        // {
        //   label: this.i18n('labelResume.passportNumber'),
        //   field: 'passportNumber',
        //   formOption: {
        //     span: 4,
        //   },
        // },
        // {
        //   label: this.i18n('labelResume.passportExpiryDate'),
        //   field: 'passportExpiryDate',
        //   formOption: {
        //     span: 4,
        //   },
        // },
        // {
        //   label: this.i18n('labelResume.passportIssuancePlace'),
        //   field: 'passportIssuancePlace',
        //   formOption: {
        //     span: 4,
        //   },
        // },
        {
          label: this.i18n('labelResume.createTime'),
          field: 'createTime',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            type: 'dateTime',
            span: 4,
          },
        },

        {
          label: this.i18n('labelResume.confirmFile'),
          field: 'dowload',
          hide: true,
          columnOptionHide: true,
          formOption: {
            slot: true,
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.latestPayslip'),
          field: 'latestPayslipFiles',
          formOption: {
            type: 'upload',
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.expectedSalary'),
          field: 'expectedSalary',
          formOption: {
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.nricFile'),
          field: 'nricFileFiles',
          formOption: {
            type: 'upload',
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.highestQualificationCert'),
          field: 'highestQualificationCertFiles',
          formOption: {
            type: 'upload',
            span: 4,
          },
        },
        {
          label: this.i18n('labelResume.trainingCertificate'),
          field: 'trainingCertificateFiles',
          formOption: {
            type: 'upload',
            span: 4,
          },
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
    interviewResultOption() {
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: this.interviewResultColumns,
      }
      return option
    },
    leaderProcessOption() {
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: this.leaderProcessColumns,
      }
      return option
    },
    formatData() {
      const res = this.data

      this.option.columns.forEach((item) => {
        const val = res[item.field]
        if (val || val === 0) {
          const type = item.formOption ? item.formOption.type : ''
          let formatVal =
            this.hasToStringTypes.indexOf(type) !== -1 ? val.toString() : val
          if (item.field === 'mobile') {
            formatVal = formatPhoneNumber(formatVal)
          }
          res[item.field] = formatVal
        }
      })
      if (!res.feedbackScore) {
        res.feedbackScore = '0,0,0,0,0'
      }
      console.log(res, 'resresresres')
      return res
    },
    formatHistoryData() {
      const res = []
      const temp = this.historyData
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return b.endTime > a.endTime ? -1 : 1
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (
          i === this.historyData.length - 1 &&
          !item.historyActivityName &&
          this.historyData.length > 2
        ) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`
        if (!item.historyActivityDurationTime && i > 0) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push({
          title,
          tip,
          info,
          remark,
          variant,
        })
      })
      return res
    },
    leaderApprovalTime() {
      const t = this.historyData2
      if (t.length > 0) {
        return t[t.length - 1].endTime
      }
      return ''
    },
    formatHistoryData2() {
      const res = []
      const temp = this.historyData2
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return b.endTime > a.endTime ? -1 : 1
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (
          i === this.historyData2.length - 1 &&
          !item.historyActivityName &&
          this.historyData2.length > 2
        ) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeAccount}`
        const remark = `Remarks: ${item.comment}`
        if (!item.historyActivityDurationTime && i > 0) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push({
          title,
          tip,
          info,
          remark,
          variant,
        })
      })
      return res
    },
  },
  mounted() {
    if (this.id) {
      this.onLoad(this.id)
      getParamList(1, -1).then((res) => {
        const temp = res.data.data.records
        this.confirmInterviewUrl =
          temp.find((o) => o.paramKey === 'interview_invitation_url')
            .paramValue + this.id
        this.confirmPassUrl =
          temp.find((o) => o.paramKey === 'interview_pass_url').paramValue +
          this.id
        this.confirmOfferUrl =
          temp.find((o) => o.paramKey === 'offer_pass_url').paramValue + this.id
        this.webUrl = temp.find((o) => o.paramKey === 'hr_web_url').paramValue
      })
    }
  },
  methods: {
    clarificationValue(field) {
      const value = this.confirmInfoData[field]
      return value === null || value === undefined ? '' : value.toString()
    },
    refreshColumn(column) {
      const c = column
      const g = []
      c.forEach((item) => {
        let isHide = !item.type
        if (item.field === 'internship') {
          isHide =
            this.leaderProcessData.offerTemplate !== 'offer_parmanent' &&
            this.leaderProcessData.offerTemplate !== 'offer_contract' &&
            this.leaderProcessData.offerTemplate !== 'offer_Internship'
        }
        if (item.field === 'noticePeriod') {
          isHide =
            this.leaderProcessData.offerTemplate !== 'offer_parmanent' &&
            this.leaderProcessData.offerTemplate !== 'offer_contract'
        }
        if (item.field === 'workWeekBasis') {
          isHide = this.leaderProcessData.offerTemplate !== 'offer_Internship'
        }
        if (item.field === 'commenceDate') {
          isHide = this.leaderProcessData.offerTemplate !== 'offer_Internship'
        }
        if (item.field === 'endDate') {
          isHide = this.leaderProcessData.offerTemplate !== 'offer_Internship'
        }
        if (item.field === 'contractPeriod') {
          isHide = this.leaderProcessData.offerTemplate !== 'offer_contract'
        }
        const newItem = {
          ...item,

          hide: isHide,
        }
        newItem.formOption.hide = isHide
        g.push(newItem)
      })
      console.log(g)
      return g
    },
    onLoad(id) {
      this.loading = true
      interviewAPI.detail({ id }).then((res) => {
        this.data = res.data.data
        // this.data.entryProcessId = '1514131924149342210'
        // if (this.data.status >= 16) {
        //   this.processLoading = true
        //   interviewAPI.getInterviewProcess({ id }).then(r => {
        //     this.processInstanceId = r.data.data.processInstanceId
        //     applyAPI.history({ processInstanceId: this.processInstanceId }).then(applyRes => {
        //       this.historyData = applyRes.data.data
        //       this.processLoading = false
        //     })
        //   })
        // }
        if (this.data.status >= 21) {
          this.processLoading = true
          interviewAPI.getLeaderInterviewProcess({ id }).then((r) => {
            this.formName = r.data.data.formName

            this.processInstanceId2 = r.data.data.processInstanceId
            applyAPI
              .history({ processInstanceId: this.processInstanceId2 })
              .then((applyRes) => {
                this.historyData2 = applyRes.data.data
                this.processLoading2 = false
              })
            this.leaderProcessData = r.data.data.map
            this.leaderProcessApprovers =
              getStore({
                name: `dictsStaticData-staff-${this.leaderProcessData.assignees}`,
              }) || []
            this.leaderProcessCreateTime = r.data.data.createTime
            templateFormAPI
              .detail({ formId: this.interviewLeaderFormId })
              .then((templateRes) => {
                const temp = templateRes.data.data.records
                this.leaderProcessColumns = this.refreshColumn(
                  templateFormat(temp)
                ) // , setDictQuery)
              })
          })
        }
        if (this.data.status >= 6 || this.data.status >= 8) {
          templateFormAPI
            .detail({ formId: this.interviewPassFormId })
            .then((templateRes) => {
              const temp = templateRes.data.data.records
              this.interviewResultColumns = templateFormat(temp) // , setDictQuery)
              interviewAPI.interviewresult({ id }).then((r) => {
                this.interviewResultData = r.data.data
              })
            })
        }

        resumeAPI.detail({ id: this.data.resumeId }).then((resumeRes) => {
          this.resumeData = resumeRes.data.data
        })

        if (this.data.status > 8) {
          interviewAPI.interviewinfoDetail({ interviewId: id }).then((r) => {
            console.log(r, 'confirmInfoDataconfirmInfoData')
            this.confirmInfoData = r.data.data
          })
        }
        this.loading = false
      })
    },
    viewPageOnLoaded(e) {
      this.OnboardingProcessCreateTime = e.createTime
    },
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    dowloadConfirmFile() {
      let hasAttach = false
      if (this.confirmInfoData.confirmFileFiles) {
        if (this.confirmInfoData.confirmFileFiles.link) {
          const url = this.confirmInfoData.confirmFileFiles.link
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          const fileName = this.confirmInfoData.enName
          link.setAttribute('download', fileName)
          link.click()
          hasAttach = true
        }
      }
      if (!hasAttach) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.userNotupload'),
            variant: 'danger',
          },
        })
      }
    },
    dowloadResume() {
      let hasAttach = false
      console.log(this.resumeData, '(this.resumeData')
      if (this.resumeData.attach) {
        if (this.resumeData.attach.link) {
          const url = this.resumeData.attach.link
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          const fileName = this.resumeData.name
          link.setAttribute('download', fileName)
          link.click()
          hasAttach = true
        }
      }

      if (!hasAttach) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.userNotupload'),
            variant: 'danger',
          },
        })
      }
    },
    handleShare() {
      this.shareModalShow = true
    },
    handlePrint() {
      const key = 'interviewResultInfo'
      setStore({
        name: key,
        content: this.interviewResultData,
      })
      const p = this.$router.resolve({ path: '/interviewPrint' })
      window.open(`${p.href}?key=${key}`, '_bank')
    },
    changeStep(b, index) {
      if (b) {
        this.currentStep = index
      }
    },
    dateFormat(e) {
      if (e) {
        return moment(e).format('DD/MM/YYYY')
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.interview-form {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
  }
}
.interview-view {
  height: 100%;
  overflow: hidden;
  &__share {
    position: absolute;
    top: -50px;
    right: 50px;
  }
  .steps {
    margin: 0 auto;
    width: calc(100% - 40px);
  }
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  &-content {
    height: calc(100% - 100px);
    overflow: auto;
  }
}
</style>
<style lang="scss">
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.interview-view {
  .ant-steps-item {
    text-align: left;
    padding-left: 25px;
    &-content {
      cursor: pointer;
      &:hover {
        .ant-steps-item-title,
        .ant-steps-item-subtitle,
        .ant-steps-item-description {
          color: $primary;
          user-select: none;
        }
      }
      .ant-steps-item-title {
        // transform: translateX(30px);
      }
    }
    &-active {
      &::before {
        // display: none;
      }
    }
    &-wait {
      cursor: not-allowed !important;
      &:hover {
        .ant-steps-item-title,
        .ant-steps-item-subtitle,
        .ant-steps-item-description {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed !important;
        }
      }
    }
    &-container {
      padding-bottom: 5px;
    }
  }
  .ant-steps-item-description {
    white-space: nowrap !important;
    font-size: 12px;
  }
  .ant-steps-item-icon {
    // transform: translateX(30px);
    .ant-steps-icon {
      cursor: pointer;
      user-select: none;
      i {
        transform: translateY(-3px);
      }
    }
  }
}
.feedback-box {
  // padding: 0 1.5rem !important;
  .ant-collapse {
    background-color: #ffffff !important;
    border: none !important;
  }
  .ant-collapse-header {
    color: #7367f0 !important;
    font-size: 20px;
    font-weight: 500;
  }
  p {
    color: #7367f0;
    font-size: 21px;
    font-weight: 500;
  }
  .feedback-content {
    color: #7367f0;
    font-size: 20px;
  }
}
</style>
